import React, { Component } from "react";
import { connect } from "react-redux";
import Store from "../../content/Store";
import Content from "../../content/Content";
import ChangeBankDetailsInLine from "./ChangeBankDetailsInLine";
import { withRouter, Link } from "react-router-dom";
import { Paths } from "../../constants/UrlConstants";

import commonStyles from "../../assets/css/modules/myprofile/change-profile-common.css";


export const mapStateToProps = ({ policyReducer = {} }) => {
    const selectedPolicy = policyReducer.selectedPolicy;
    return {
        MembershipNumber: selectedPolicy && selectedPolicy.MembershipNumber,
        IsFormat2: selectedPolicy && selectedPolicy.IsFormat2,
    };
};


class ChangeBankDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            singleEditMode: false,
            Title: Store.ChangeBankDetails.Title,
            SubTitle: Store.ChangeBankDetails.SubTitle,
        };
        this.sizeResize = this.sizeResize.bind(this);

    }
    componentDidMount() {
        console.log("Componentdid");

        window.addEventListener("resize", this.sizeResize);

    }

    // componentWillUnmount() {
    //     console.log("unmount");
    //     window.removeEventListener("resize", this.sizeResize);
    // }


    // resizeScreen() {
    //     console.log("resizeScreen");
    //     console.log(window?.innerWidth);

    //     if(window.innerWidth < 768)
    //     {
    //         this.setState({Title:Store?.ChangeBankDetails?.MobTitle});
    //         this.setState({SubTitle:Store?.ChangeBankDetails?.SubTitleForMob});
    //     }

    // }

    sizeResize() {
        console.log("sizeResize");
        console.log(window?.innerWidth);
        if (window.innerWidth <= 375) {
            console.log(window?.innerWidth);
            this.setState({ Title: Store?.ChangeBankDetails?.MobTitle });

            this.setState({ SubTitle: Store?.ChangeBankDetails?.SubTitleForMob });
        } else if (window.innerWidth < 768 && window.innerWidth > 375) {
            this.setState({ Title: Store?.ChangeBankDetails?.Title });

            this.setState({ SubTitle: Store?.ChangeBankDetails?.SubTitleAlign });
        } else {
            this.setState({ Title: Store?.ChangeBankDetails?.Title });

            this.setState({ SubTitle: Store?.ChangeBankDetails?.SubTitle });
        }

    }


    render() {

        // let SubTitle = Store.ChangeBankDetails.SubTitle;
        // let Title = Store.ChangeBankDetails.Title;
        // let width = window?.innerWidth;
        // console.log(width);
        // if (width < 768) {
        //     Title = Store.ChangeBankDetails.MobTitle;
        //     SubTitle = Store.ChangeBankDetails.SubTitleForMob;
        // } else {
        //     Title = Store.ChangeBankDetails.Title;
        //     SubTitle = Store.ChangeBankDetails.SubTitle;
        // }

        return (
            <div className={commonStyles.changeProfile} >
                <h1 className="axa-headline" style={{textAlign:"center" }}>
                    <Content name={Store?.ChangeBankDetails?.Title} />
                </h1>
                <p style={{textAlign:"center"}}><Content name={Store?.ChangeBankDetails?.SubTitle}></Content></p>
                <div id="memberBank">
                    <ChangeBankDetailsInLine
                        bankInfo={this.state.bankInfo}
                        IsFormat2={this.props.IsFormat2}
                        DisableEdit={this.state.singleEditMode}

                        HandleEdit={() => {
                            this.setState({
                                singleEditMode: true
                            });
                        }}
                        CallBackParent={() => {
                            this.setState({
                                singleEditMode: false
                            });
                        }}

                    />

                </div>
                <div className={commonStyles.actionButtons}>
                    <div className="col-sm-6 back-button">
                        <Link to={Paths.MyProfile}>
                            <span className="mr-2 left-arrow-back">←</span>{" "}
                            <Content name={Store.ChangeProfileCommon.BackButtonLabel} />
                        </Link>
                    </div>
                </div>


            </div>
        );
    }
}

export default withRouter(connect(mapStateToProps)(ChangeBankDetails));
